"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CwNotificationStatus = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwImage = _interopRequireDefault(require("../cwimage/CwImage"));

var _CwFlexbox = _interopRequireDefault(require("../cwflexbox/CwFlexbox"));

var _CwNotification = _interopRequireDefault(require("./CwNotification.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _IconPath = _interopRequireDefault(require("../../utils/IconPath"));

var CwNotificationStatus = {
  ERROR: 'Error',
  INFORMATIONAL: 'Informational',
  WARNING: 'Warning',
  SUCCESSFUL: 'Successful'
};
exports.CwNotificationStatus = CwNotificationStatus;

var CwNotification = function CwNotification(props) {
  var _cx;

  var wrapClass = (0, _classnames.default)((_cx = {}, (0, _defineProperty2.default)(_cx, _CwNotification.default.wrap, true), (0, _defineProperty2.default)(_cx, props.className, props.className), (0, _defineProperty2.default)(_cx, _CwNotification.default.error, props.status === CwNotificationStatus.ERROR), (0, _defineProperty2.default)(_cx, _CwNotification.default.informational, props.status === CwNotificationStatus.INFORMATIONAL), (0, _defineProperty2.default)(_cx, _CwNotification.default.warning, props.status === CwNotificationStatus.WARNING), (0, _defineProperty2.default)(_cx, _CwNotification.default.successful, props.status === CwNotificationStatus.SUCCESSFUL), _cx));
  return _react.default.createElement("div", {
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    "data-cwid": props.cwId,
    style: props.style,
    className: wrapClass
  }, _react.default.createElement(_CwFlexbox.default, {
    verticalAlign: true
  }, _react.default.createElement(_CwImage.default, {
    src: props.statusIcon,
    className: _CwNotification.default.icon
  }), _react.default.createElement("div", {
    className: _CwNotification.default.text
  }, props.message), _react.default.createElement(_CwImage.default, {
    src: props.closeIcon,
    className: _CwNotification.default.icon,
    onClick: props.onClose
  })), props.children ? _react.default.createElement("div", {
    className: _CwNotification.default.children
  }, props.children) : null);
};

CwNotification.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,
  status: _propTypes.default.oneOf([CwNotificationStatus.ERROR, CwNotificationStatus.INFORMATIONAL, CwNotificationStatus.WARNING, CwNotificationStatus.SUCCESSFUL]).isRequired,
  statusIcon: _propTypes.default.string.isRequired,
  closeIcon: _propTypes.default.string,
  message: _propTypes.default.element.isRequired,
  onClose: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  style: _propTypes.default.object,

  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes.default.func,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.element), _propTypes.default.element])
};
CwNotification.defaultProps = {
  closeIcon: _IconPath.default.get('Action_Close')
};
var _default = CwNotification;
exports.default = _default;